import Cookies from "js-cookie";

import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import { FaBookBookmark, FaFileLines, FaPeopleGroup } from "react-icons/fa6";

import NavBar from "../components/NavBar";
import Header from "../components/Header";
import { FaChartPie } from "react-icons/fa";

const Home = () => {
  const headerStr = "Welcome, " + Cookies.get("username");

  return (
    <div>
      <NavBar />
      <div className="container-content-fixed">
        <Header title={headerStr} />
        <CardGroup className="admin-home-card-grp">
        <Card>
            <a href="/statistics" className="admin-home-card">
              <Card.Body className="text-center">
                <FaChartPie className="admin-home-card-icon" />
                <Card.Title>Statistics</Card.Title>
                <Card.Text>
                  View the statistics on courses.
                </Card.Text>
              </Card.Body>
            </a>
          </Card>
          <Card>
            <a href="/edit-courses" className="admin-home-card">
              <Card.Body className="text-center">
                <FaBookBookmark className="admin-home-card-icon" />
                <Card.Title>Courses</Card.Title>
                <Card.Text>
                  Manage courses and classes details.
                </Card.Text>
              </Card.Body>
            </a>
          </Card>
          <Card>
            <a href="/edit-resources" className="admin-home-card">
              <Card.Body className="text-center">
                <FaFileLines className="admin-home-card-icon" />
                <Card.Title>Resources</Card.Title>
                <Card.Text>
                  Manage course resources and user guides.
                </Card.Text>
              </Card.Body>
            </a>
          </Card>
          <Card>
            <a href="/edit-team" className="admin-home-card">
              <Card.Body className="text-center">
                <FaPeopleGroup className="admin-home-card-icon" />
                <Card.Title>Team</Card.Title>
                <Card.Text>
                  Edit team details.
                </Card.Text>
              </Card.Body>
            </a>
          </Card>
        </CardGroup>
      </div>
    </div>
  );
};

export default Home;
